import React from "react";
import Icon from "../AppIcon";
import rocketLogo from "../../assets/rocket-logo.png";

/**
 * Shared left-side branding panel for all auth pages (login, forgot-password,
 * reset-password, accept-invitation).
 *
 * Colours, logo, and copy must stay in sync with the login page.
 */
const AuthBrandPanel = () => (
  <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
    {/* Background gradient */}
    <div className="absolute inset-0 bg-gradient-to-br from-[#1a2b4b] via-[#243a5e] to-[#1a2b4b]" />

    {/* Accent blurs */}
    <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF5A5F] rounded-full opacity-10 blur-3xl transform translate-x-1/2 -translate-y-1/2" />
    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#00C9A7] rounded-full opacity-10 blur-3xl transform -translate-x-1/2 translate-y-1/2" />

    <div className="relative z-10 flex flex-col justify-between p-12 text-white w-full">
      {/* Logo */}
      <div>
        <img
          src={rocketLogo}
          alt="Rocket"
          className="h-12 w-auto brightness-0 invert"
        />
      </div>

      {/* Tagline */}
      <div className="space-y-8">
        <div>
          <h1 className="text-5xl font-heading font-bold leading-tight mb-4">
            <span className="text-white">TRONC Management</span>
            <br />
            <span className="text-[#FF5A5F]">Made Simple</span>
          </h1>
          <p className="text-lg text-white/80 max-w-md leading-relaxed">
            Automate your tip distribution, ensure compliance, and keep your
            team happy with transparent TRONC management.
          </p>
        </div>
      </div>

      {/* Copyright */}
      <p className="text-sm text-white/40">
        &copy; {new Date().getFullYear()} Rocket. All rights reserved.
      </p>
    </div>
  </div>
);

export default AuthBrandPanel;
